import { createContext, useContext } from 'react';

export const CloseNavContext = createContext<() => void>(() => {});

/** Lets links nested in the sidebar close the mobile drawer after navigating. */
export const useCloseShellNav = () => useContext(CloseNavContext);

/** The main panel, which scrolls instead of the window. */
export const ScrollAreaContext = createContext<HTMLElement | null>(null);

export const useShellScrollArea = () => useContext(ScrollAreaContext);
